import React from 'react';
import { Layout } from '../../components/Boneyard';
import { white } from '../../theme/theme/colors';

import { withValue } from '@g4/automation-hooks';
import {
  HIGHLIGHTED_DEALS_TITLE,
  HIGHLIGHTED_DEALS,
  HIGHLIGHTED_DEALS_SECTION,
} from '../../../automationHooks';
import IndexPageSection from './highlightedDealsSection/IndexPageSection';
import DealsCard from './highlightedDealsSection/highlitedDeals/DealsCard';
import HighlightedDeals from './highlightedDealsSection/HighlightedDeals';
import { VerticalSpacing } from '../../components/Boneyard';
import HIGHLIGHTED_DEALS_QUERY from './highlightedDealsSection/highlightedDeals.query.graphql';
import { useSSRQuery } from '../../graphql';

const HighlightedDealsSection = () => {
  const { loading, error, data } = useSSRQuery(HIGHLIGHTED_DEALS_QUERY);
  const highlightedDeals =
    data?.application?.highlightedDealsConfigurations?.highlightedDeals;
  const highlightedDealsConfigurations =
    data?.application?.highlightedDealsConfigurations;
  const highlightedDealCycleDelay =
    data?.application?.highlightedDealsConfigurations
      ?.highlightedDealsCycleDelay;

  if (error || loading || !highlightedDealsConfigurations) {
    return null;
  }

  if (highlightedDeals) {
    return (
      <React.Fragment>
        <Layout.Strip color={white} id={'tester+5'}>
          <IndexPageSection
            title={'Highlighted Deals'}
            titleAutomationHook={HIGHLIGHTED_DEALS_TITLE.hook}
          >
            <HighlightedDeals
              highlightedDealCycleDelay={highlightedDealCycleDelay}
              automationHook={HIGHLIGHTED_DEALS_SECTION.hook}
            >
              {highlightedDeals.map((deal, index) => (
                <DealsCard
                  title={deal.title}
                  cardTitle={deal.cardTitle}
                  key={index}
                  positionGA={index}
                  ribbon={deal.ribbon}
                  desktopImage={deal.desktopImage}
                  mobileImage={deal.mobileImage}
                  description={deal.description}
                  ctaLabel={deal.ctaLabel}
                  url={deal.clickThrough.url}
                  target={`_${deal.clickThrough.target.toLowerCase()}`}
                  automationHook={withValue(HIGHLIGHTED_DEALS.hook, index)}
                />
              ))}
            </HighlightedDeals>
            <VerticalSpacing size={5} />
          </IndexPageSection>
        </Layout.Strip>
      </React.Fragment>
    );
  }

  return null;
};

export default HighlightedDealsSection;
